import { Circle, Square } from 'lucide-react';
import { sortBySortOrder } from '@/utils/sort';
import type { SurveyQuestionDetail } from '../../types/survey.types';
import { EmptyOptionsNote } from './EmptyOptionsNote';

interface SurveyChoicePreviewProps {
  question: SurveyQuestionDetail;
  variant: 'mcq' | 'checkbox';
}

export function SurveyChoicePreview({ question, variant }: SurveyChoicePreviewProps) {
  const OptionIcon = variant === 'mcq' ? Circle : Square;
  const sortedOptions = sortBySortOrder(question.options);

  if (sortedOptions.length === 0) return <EmptyOptionsNote />;

  return (
    <ul className="space-y-2">
      {sortedOptions.map((option) => (
        <li
          key={option.id}
          className="flex min-w-0 items-center gap-2.5 rounded-md border bg-card px-3 py-2 text-sm"
        >
          <OptionIcon className="size-4 shrink-0 text-muted-foreground" />
          <span className="min-w-0 wrap-break-word">{option.text}</span>
        </li>
      ))}
    </ul>
  );
}
